export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// export const PHONE_NUMBER_REGEX =
// /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const PHONE_NUMBER_REGEX =
  /^[+]{1}(?:[0-9\\-\\(\\)\\/""\\.]\\s?){6,15}[0-9]{1}$/;

export const GEO_LOCATION_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
